import React from 'react';
import { RefreshCwIcon } from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import { Sizes } from '@newcore/ui/enums/sizes';
import { AlertVariants, ButtonVariants } from '@newcore/ui/enums/variants';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface ErrorAlertWithRetryProps {
  message: string;
  onRetry: () => void;
  className?: string;
}

export const ErrorAlertWithRetry: React.FC<ErrorAlertWithRetryProps> =
  React.memo(({ message, onRetry, className }) => {
    return (
      <Alert variant={AlertVariants.DESTRUCTIVE} className={className}>
        <AlertDescription className='flex items-center justify-between'>
          <span>{message}</span>
          <Button
            variant={ButtonVariants.SECONDARY}
            size={Sizes.SM}
            onClick={onRetry}
          >
            <RefreshCwIcon className='h-4 w-4 mr-2' />
            Retry
          </Button>
        </AlertDescription>
      </Alert>
    );
  });

ErrorAlertWithRetry.displayName = 'ErrorAlertWithRetry';
